// extracted by mini-css-extract-plugin
module.exports = {"slide":"MemberOrdersDespoit_slide_3JmNW","slide-reverse":"MemberOrdersDespoit_slide-reverse_2qZpa","MemberOrdersDespoit":"MemberOrdersDespoit_MemberOrdersDespoit_1QWtR"};